module.exports = __webpack_public_path__ + "static/media/mom-baby-massage.027b3b29.webp";